import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { DateRange } from 'components/RangeDatePicker'
import ExportsActions from 'pages/Exports/components/ExportsActions'
import { InOutDescription } from './styles'
import { useMutation } from '@apollo/client'
import { GreffeExportResult, GreffeExportVariables, GREFFE_EXPORT } from 'pages/Exports/mutations'
import { displayErrors, hasNoError } from 'globals/graphql'

interface IProps {
  onShowExportConfirmation: () => void
}

const InOut = (props: IProps) => {
  const { onShowExportConfirmation } = props
  const { t } = useTranslation()
  const [dateRange, setDateRange] = useState<DateRange>()

  const [greffeExport] = useMutation<GreffeExportResult, GreffeExportVariables>(GREFFE_EXPORT, displayErrors)

  const onExport = (
      onShowExportConfirmation: () => void,
      dateRange?: DateRange
  ) => () =>
    dateRange && greffeExport({
      variables: {
        startingDate: dateRange.startDate.toISOString(),
        endingDate: dateRange.endDate.toISOString()
      }
    }).then(
        hasNoError(() =>
          onShowExportConfirmation()
        )
    )

  return (
    <div>
      <ExportsActions
        onExport={onExport(onShowExportConfirmation, dateRange)}
        onDateRangeSelected={setDateRange}
      />

      <InOutDescription>
        <span>{t('exports.in-out.description')}</span>
      </InOutDescription>
    </div>
  )
}

export default InOut
